module.exports = __webpack_public_path__ + "assets/img/system-point-banner1.da4ba085.png";